import { useEffect, useState } from 'react';

export const useScrolledToBottom = () => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    if (!ref) {
      setIsBottom(false);
      return;
    }

    const handleScroll = () => {
      const { clientHeight, scrollTop, scrollHeight } = ref;
      if (isBottom !== clientHeight + scrollTop >= scrollHeight - 1) {
        setIsBottom(!isBottom);
      }
    };

    ref.addEventListener('scroll', handleScroll);

    return () => ref.removeEventListener('scroll', handleScroll);
  }, [ref, isBottom]);

  const resetPosition = () => {
    if (!ref) {
      return;
    }

    ref.scrollTo(0, 0);
  };

  return { isBottom, setRef, resetPosition };
};
